'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactResizeDetector = require('react-resize-detector');

var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);

var _reactackleCore = require('reactackle-core');

var _HeaderStyled = require('./styles/HeaderStyled');

var _HeaderWrapperStyled = require('./styles/HeaderWrapperStyled');

var _HeaderContentWrapperStyled = require('./styles/HeaderContentWrapperStyled');

var _HeaderBackgroundContainerStyled = require('./styles/HeaderBackgroundContainerStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('header', _theme2.default);
var propTypes = {
  /**
   * Background image url
   */
  backgroundImage: _propTypes2.default.string,

  /**
   * Customize header background color
   */
  backgroundColor: _propTypes2.default.string,

  /**
   * Define header position. Fixed header will be always visible on the screen.
   */
  behavior: _propTypes2.default.oneOf(['static', 'fixed']),

  /**
   * If true, the header's height will condense to condensedHeaderHeight as the
   * user scrolls down from the top of the content area.
   * @type {boolean}
   * @default false
   */
  // eslint-disable-next-line react/no-unused-prop-types
  condenses: _propTypes2.default.bool,

  /**
   * If true, the condensed header is always shown and does not move away.
   * @type {boolean}
   * @default false
   */
  keepCondensedHeader: _propTypes2.default.bool,

  /**
   * The height of the header when it is condensed.
   * @type {number}
   * @default 0
   */
  condensedHeaderHeight: _propTypes2.default.number,

  /**
   * Define header's padding size. 'Blank' means zero paddings.
   */
  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),

  /**
   * Specify function to call when Header offset is changed
   */
  onChangeOffset: _propTypes2.default.func
};
var defaultProps = {
  backgroundImage: '',
  backgroundColor: '',
  behavior: 'static',
  condenses: false,
  keepCondensedHeader: false,
  condensedHeaderHeight: 0,
  size: 'default',
  onChangeOffset: _reactackleCore.noop
};

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this._scrollListened = false;
    _this._refHeader = null;
    _this._refWrapper = null;
    _this._headerHeight = null;
    _this._headerOffset = null;
    _this._saveRefHeader = _this._saveRefHeader.bind(_this);
    _this._saveRefWrapper = _this._saveRefWrapper.bind(_this);
    _this._handleScroll = _this._handleScroll.bind(_this);
    _this._applyHeaderStyle = _this._applyHeaderStyle.bind(_this);
    return _this;
  }

  _createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _refHeader$getBoundin = this._refHeader.getBoundingClientRect(),
          width = _refHeader$getBoundin.width;

      var _refWrapper$getBoundi = this._refWrapper.getBoundingClientRect(),
          height = _refWrapper$getBoundi.height;

      this._applyHeaderStyle({
        width: width,
        height: height
      });

      this._toggleScrollListener();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._toggleScrollListener(this._isCondensed(nextProps));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._toggleScrollListener(false);
    }
  }, {
    key: '_isCondensed',
    value: function _isCondensed() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return source.condenses;
    }
  }, {
    key: '_toggleScrollListener',
    value: function _toggleScrollListener() {
      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._isCondensed();

      if (condition && !this._scrollListened) {
        this._scrollListened = true;
        window.addEventListener('scroll', this._handleScroll);
      } else if (!condition && this._scrollListened) {
        this._scrollListened = false;
        window.removeEventListener('scroll', this._handleScroll);
      }
    }
  }, {
    key: '_handleScroll',
    value: function _handleScroll() {
      var _props = this.props,
          condensedHeaderHeight = _props.condensedHeaderHeight,
          keepCondensedHeader = _props.keepCondensedHeader;
      var finalHeaderOffset = keepCondensedHeader ? this._headerHeight - condensedHeaderHeight : this._headerHeight;
      var newWindowOffset = window.pageYOffset;
      var newHeaderOffset = newWindowOffset > finalHeaderOffset ? finalHeaderOffset : newWindowOffset;

      if (this._headerOffset !== newHeaderOffset) {
        this._applyHeaderStyle({
          offset: newHeaderOffset
        });

        this.props.onChangeOffset({
          offset: newHeaderOffset
        });
      }
    }
  }, {
    key: '_applyHeaderStyle',
    value: function _applyHeaderStyle(_ref) {
      var height = _ref.height,
          width = _ref.width,
          offset = _ref.offset;

      if (!(0, _reactackleCore.isUndef)(height)) {
        this._headerHeight = height;
        this._refHeader.style.height = height + 'px';
      }

      if (!(0, _reactackleCore.isUndef)(width)) this._refWrapper.style.width = width + 'px';

      if (!(0, _reactackleCore.isUndef)(offset)) {
        this._headerOffset = offset;
        this._refWrapper.style.transform = 'translateY(-' + offset + 'px)';
      }
    }
  }, {
    key: '_saveRefHeader',
    value: function _saveRefHeader(ref) {
      this._refHeader = ref;
    }
  }, {
    key: '_saveRefWrapper',
    value: function _saveRefWrapper(ref) {
      this._refWrapper = ref;
    }
  }, {
    key: '_renderInnerBackground',
    value: function _renderInnerBackground() {
      var backgroundImage = this.props.backgroundImage;
      if (!backgroundImage) return null;
      return _react2.default.createElement(_HeaderBackgroundContainerStyled.HeaderBackgroundContainerStyled, {
        style: {
          backgroundImage: 'url(' + backgroundImage + ')'
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          behavior = _props2.behavior,
          size = _props2.size,
          backgroundColor = _props2.backgroundColor,
          children = _props2.children;

      var innerBg = this._renderInnerBackground();

      return _react2.default.createElement(_HeaderStyled.HeaderStyled, {
        size: size,
        customBackgroundColor: backgroundColor,
        innerRef: this._saveRefHeader
      }, _react2.default.createElement(_HeaderWrapperStyled.HeaderWrapperStyled, {
        innerRef: this._saveRefWrapper,
        size: size,
        behavior: behavior,
        customBackgroundColor: backgroundColor
      }, innerBg, _react2.default.createElement(_HeaderContentWrapperStyled.HeaderContentWrapperStyled, null, children)), _react2.default.createElement(_reactResizeDetector2.default, {
        handleWidth: true,
        onResize: function onResize(width) {
          return _this2._applyHeaderStyle({
            width: width
          });
        }
      }));
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
Header.displayName = 'Header';